import script from "./PropertyData.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyData.vue?vue&type=script&setup=true&lang=js"

import "./PropertyData.vue?vue&type=style&index=0&id=29ee3766&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29ee3766"]])

export default __exports__